import { render, staticRenderFns } from "./Inherit.vue?vue&type=template&id=7568dd7a&scoped=true&lang=pug&"
import script from "./Inherit.vue?vue&type=script&lang=js&"
export * from "./Inherit.vue?vue&type=script&lang=js&"
import style0 from "./Inherit.vue?vue&type=style&index=0&id=7568dd7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568dd7a",
  null
  
)

export default component.exports